import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'fip-setting',
    templateUrl: './fip-setting.component.html',
    styleUrls: ['./fip-setting.component.scss'],
    standalone: false
})
export class FipSettingComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
